import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { MdArrowBack, MdChevronRight, MdHistory } from 'react-icons/md';

const ChatHistoryScreen = ({ onNavigate, onBack, sessions, onResumeSession }) => {
  const [expandedId, setExpandedId] = useState(null);

  return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('chat'))} aria-label="Back to chat">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Chat History</h1>
        </div>
        <MdHistory size={22} style={{ color: 'var(--bh-black)' }} />
      </header>

      <div className="scroll-content gray-bg">
        {sessions.length === 0 ? (
          <div className="chat-history-empty">
            <MdHistory className="chat-history-empty-icon" />
            <h3>No saved sessions</h3>
            <p>Start a conversation and tap <strong>New Chat</strong> — the current session will be saved here automatically.</p>
          </div>
        ) : (
          [...sessions].reverse().map(session => (
            <div key={session.id} className="chat-history-card">
              <div
                className="chat-history-card-header"
                onClick={() => setExpandedId(expandedId === session.id ? null : session.id)}
              >
                <div className="chat-history-card-meta">
                  <div className="chat-history-preview">{session.title || session.preview}</div>
                  {session.title && <div className="chat-history-subtitle">{session.preview}</div>}
                  <div className="chat-history-info">
                    {session.timestamp} · {session.messageCount} message{session.messageCount !== 1 ? 's' : ''}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                  <button
                    className="chat-history-resume-btn"
                    onClick={(e) => { e.stopPropagation(); onResumeSession(session); onNavigate('chat'); }}
                  >
                    Resume
                  </button>
                  <MdChevronRight
                    className="chat-history-chevron"
                    style={{ transform: expandedId === session.id ? 'rotate(90deg)' : 'none', transition: 'transform 0.2s' }}
                  />
                </div>
              </div>

              {expandedId === session.id && (
                <div className="chat-history-thread">
                  {session.history.map(msg => (
                    <div key={msg.id} className={`chat-history-msg ${msg.isUser ? 'user' : 'bot'}`}>
                      <div className="chat-history-bubble">
                        {msg.isBot
                          ? <ReactMarkdown remarkPlugins={[remarkGfm]}>{msg.text}</ReactMarkdown>
                          : msg.text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ChatHistoryScreen;
